import { useFormat } from '@ideavivat/vivat-2';

export default {
  types: {
    _primaryControls: {
      width: '4rem',
    },
    _increment: {
      name: 'ลำดับ',
      width: '4rem',
    },
    code: {
      name: 'รหัสบัญชี',
      width: '6rem',
    },
    name: {
      name: 'รายละเอียดค่าใช้จ่าย',
      width: '1fr',
    },
    type: {
      name: 'ประเภท',
      width: '6rem',
      filter: (val: string) => {
        if (val === 'EXPENSE') return 'รายจ่าย';
        if (val === 'INCOME') return 'รายรับ';
        return 'NA';
      },
    },
    createdAt: {
      name: 'สร้างเมื่อ',
      width: '10rem',
      filter: (val: string) => useFormat.date(val).displayShortThaiDateTime(),
    },
    updatedAt: {
      name: 'แก้ไขล่าสุด',
      width: '10rem',
      filter: (val: string) => useFormat.date(val).displayShortThaiDateTime(),
    },
    // createdAt:
  },
  sortable: [
    'code',
    'name',
    'createdAt',
    'updatedAt',
  ],
};
